module.exports = __webpack_public_path__ + "static/media/badge-instagram.884fb07b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/badge-instagram.png
// module id = 310
// module chunks = 0